import { VNTABS_SET_TAB_NAME_REQUIRED } from '../VNTabs/ActionTypes'

/**
 * Set Tab Name Required
 * This will be read by CartSidebar and CartModal components to display "Tab Name" prompt
 *
 * @param {Boolean} route
 * @param {?Object} params
 * @returns
 */
export function setIsTabNameRequired(isRequired) {
  return (dispatch) => {
    dispatch({
      type: VNTABS_SET_TAB_NAME_REQUIRED,
      isRequired,
    })
  }
}
